var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{staticClass:"custom-control-primary",attrs:{"value":_vm.value,"checked":_vm.selected,"disabled":_vm.disabled},on:{"change":function (val) { return _vm.$emit('changeFormat', val); }}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }